import * as React from 'react';

const CardDescription: React.FunctionComponent = ({ children }) => {
    return <div className="card__description">{children}</div>;
};

export { CardDescription };
